<footer
  id="dx-global-footer"
  [class.dark-mode]="darkMode"
  class="bl-bg-color--white bl-border-top--solid bl-padding-x--16 bl-padding-x-lg--40 bl-padding-y--16"
>
  <div id="footer-container" class="set-width bl-display--flex bl-margin-x--auto">
    <div id="footer-main-content" class="bl-display--flex bl-flex-direction--column bl-flex--auto bl-padding-right--16">
      <div id="footer-links" class="bl-flex--auto">
        <ul *ngIf="footerLinks" class="bl-display--flex">
          <li *ngFor="let link of footerLinks; let i = index">
            <a
              [href]="link.route"
              target="_blank"
              rel="noopener"
              class="bl-text-style--secondary-text-1 bl-font-color--base bl-text-decoration--none"
            >
              {{ link.label }}</a
            >
            <span aria-hidden="true" *ngIf="i < footerLinks.length - 1" class="bl-margin-x--8 bl-font-color--silver"> | </span>
          </li>
        </ul>
        <ng-content></ng-content>
      </div>
      <ng-container *ngTemplateOutlet="footerCopyright; context: { mobileLayout: false }"> </ng-container>
    </div>
    <div id="footer-secondary-content" class="bl-text-style--tertiary-text-1">
      <ng-content select="[footer-secondary-content]"></ng-content>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="footerCopyright; context: { mobileLayout: true }"> </ng-container>
</footer>

<ng-template #footerCopyright let-mobileLayout="mobileLayout">
  <p
    *ngIf="copyright"
    id="footer-copyright"
    class="bl-margin-bottom--0 bl-text-style--tertiary-text-1 bl-margin-top--8"
    [ngClass]="mobileLayout ? 'bl-display-md--none' : 'bl-display--none bl-display-md--block'"
    [innerHTML]="'&copy; ' + copyright"
  ></p>
</ng-template>